import React from "react"
import PropTypes from "prop-types"
import Field from "../field"
import { Fieldset as StyledFieldset } from "../../forms"

const Fieldset = ({
  name,
  legend,
  content,
  showVideoHint,
  videoUrl,
  fields,
  formState,
  handleInputChange,
  customFieldComponents,
  simpleForm,
  last,
  handleRemoveVideo
}) => {
  const onInputChange = (fieldName, value, type = null) => {
    if (handleInputChange !== undefined) handleInputChange(name, fieldName, value, type)
  }

  const showField = ({ dependent_on, dependent_value }) => {
    if (dependent_on === "") return true
    else return formState[name][dependent_on] === dependent_value
  }

  return (
    <StyledFieldset
      name={name}
      legendText={legend}
      content={content}
      showVideoHint={showVideoHint}
      videoUrl={videoUrl}
      simpleForm={simpleForm}
      last={last}
    >
      {fields.map((field) => (
        <Field
          key={`${name}_${field.name}`}
          {...field}
          fieldsetLegend={legend}
          stateValue={formState[name][field.name]}
          handleInputChange={onInputChange}
          show={showField(field)}
          customFieldComponents={customFieldComponents}
          simpleForm={simpleForm}
          loaded={formState[name]["loaded"]}
          handleRemoveVideo={handleRemoveVideo}
        />
      ))}
    </StyledFieldset>
  )
}

Fieldset.propTypes = {
  name: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  content: PropTypes.string,
  videoUrl: PropTypes.string,
  fields: PropTypes.array,
  formState: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  customFieldComponents: PropTypes.object
}

Fieldset.defaultProps = {
  fields: [],
  formState: {},
  handleInputChange: undefined,
  customFieldComponents: {}
}

export default Fieldset
